
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getMunicipalitiesByState",
      resolverType: "query",
      routePath: "/getMunicipalitiesByState",
      httpMethod: "POST",
    });
  